export const withBearer = (obj: any) => {
  const token = sessionStorage.getItem('token');
  return Object.assign(obj, { Authorization: `Bearer ${token}` });
};